





























import {
  computed,
  defineComponent,
  ref,
  useRoute
} from '~/utils/nuxt3-migration'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CDatePicker from '~/components/shared/configurable/date/CDatePicker.vue'
import { useI18n } from '~/compositions/i18n'
import { addYears, format, isAfter, parseDate } from '~/utils/date'
import { useDep } from '~/compositions/dependency-container'
import RouterService from '~/services/RouterService'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { useNamespacedStore } from '~/compositions/store'

const DATE_FORMAT = 'd/M/yyyy'

export default defineComponent({
  components: { CCard, CDatePicker },
  setup() {
    const i18n = useI18n()
    const route = useRoute()
    const routerService = useDep(RouterService)
    const { dispatch } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )

    const dateFrom = ref<Date | null>(getQueryParamDate('rental_period-from'))
    const dateTo = ref<Date | null>(getQueryParamDate('rental_period-to'))
    const today = ref(new Date())
    const oneYearLater = ref(addYears(today.value, 1))

    const locale = computed(() => i18n.locale)

    async function handleDateFromInput(date: Date) {
      // if the user selected a dateFrom that is larger than dateTo, set the dateTo as the new dateFrom
      if (dateTo.value && isAfter(date, dateTo.value)) {
        dateTo.value = date
      }
      await routerService.replaceQueryParams({
        'rental_period-from': format(date, DATE_FORMAT),
        'rental_period-to': dateTo.value && format(dateTo.value, DATE_FORMAT)
      })
      return dispatch('reloadClassifiedView')
    }
    async function handleDateToInput(date: Date) {
      await routerService.replaceQueryParams({
        'rental_period-to': format(date, DATE_FORMAT)
      })
      return dispatch('reloadClassifiedView')
    }
    function getQueryParamDate(paramName: string): Date | null {
      const queryParam = route.value.query[paramName]
      if (!queryParam) {
        return null
      }
      if (Array.isArray(queryParam) && queryParam.length) {
        return parseDate(queryParam[0] as string, DATE_FORMAT)
      }
      return parseDate(queryParam as string, DATE_FORMAT)
    }

    return {
      dateFrom,
      dateTo,
      locale,
      today,
      oneYearLater,
      handleDateFromInput,
      handleDateToInput
    }
  }
})
